/** @format */

import React from 'react';
import './style.scss';
import Navbar from '../../container/navbar';
import Card from '../../container/card';
import Footer from '../../container/footer';

const Project = () => {
	return (
		<div className='projects'>
			<Navbar />
			<Card />
			<Footer />
		</div>
	);
};
export default Project;
